import { searchParams } from "../graphDB-utils";
import { onitServerBaseURLWithoutRedirectURL } from "./onit-server-utils";

export class Twilio {

    async SendSMS(toNumber: string, messageBody: string, instance: string, callback: (message: any) => void) {
        messageBody += `, To Unsubscribe SMS Alerts: ${window.location.origin}/#${instance}/UnsubscribeSMSAlerts/FullScreen`
        const postData = { "to": toNumber, "body": messageBody }
        return await fetch(onitServerBaseURLWithoutRedirectURL + "SendSMS", {
            mode: "cors",
            method: 'POST',
            headers: {
                "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                "Accept": "application/sparql-results+json"
            },

            body: searchParams(postData)
        });
    }

    async SendSMS_Multiple(toNumbers: string[], messageBody: string, instance: string, includeUnsubscribe: boolean, callback: () => void) {
        if (includeUnsubscribe)
            messageBody += `, To Unsubscribe SMS Alerts: ${window.location.origin}/#${instance}/UnsubscribeSMSAlerts/FullScreen`;

        const postData = { "to": toNumbers, "body": messageBody }
        return await fetch(onitServerBaseURLWithoutRedirectURL + "SendMultipleSMS", {
            mode: "cors",
            method: 'POST',
            headers: {
                "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                "Accept": "application/sparql-results+json"
            },

            body: searchParams(postData)
        });
    }

}


// WEBPACK FOOTER //
// ./src/server/utils/twilio-utils.ts